import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sbpro-border',
  templateUrl: './sbpro-border.component.html',
  styleUrls: ['./sbpro-border.component.scss']
})
export class SbproBorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
